import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  max-width: 200px;
  height: 6px;
  background: #eee;
  border-radius: 3px;
  overflow: hidden;
  margin-top: 0.5rem;
`;

const Bar = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.colors.secondary};
  width: ${props => props.progress}%;
  transition: width 0.3s ease;
`;

const ProgressBar = ({ progress }) => {
  return (
    <Container>
      <Bar progress={progress} />
    </Container>
  );
};

export default ProgressBar;
